<div class="w-full h-full flex items-center justify-between"
  [class.flex-col]="legendPosition === 'bottom'"
  [class.flex-col-reverse]="legendPosition === 'top'"
  [class.flex-row]="legendPosition === 'right'"
  [class.flex-row-reverse]="legendPosition === 'left'">

  <!-- LEGEND (Top) -->
  @if(showLegend && legendPosition === 'top') {
  <div id="legendContainerTop" #legendRefTop
    class="mb-1 flex flex-wrap justify-center items-center gap-x-4 gap-y-2 w-full flex-shrink-0">
  </div>
  }

  <!-- LEGEND (Left) -->
  @if(showLegend && legendPosition === 'left') {
  <div id="legendContainerLeft" #legendRefLeft
    class="mr-1 flex flex-col justify-center h-full overflow-y-auto min-w-[140px] flex-shrink-0"
    style="max-height: 300px;">
  </div>
  }

  <!-- Chart Area -->
  <div class="flex-1 flex flex-col justify-center items-center w-full h-full min-h-0 overflow-visible">
    <div id="pieChart" #pieChartRef class="relative w-full h-full" [class.overflow-hidden]="fitToContainer()" [class.overflow-visible]="!fitToContainer()" [style.min-height]="minHeight + 'px'"></div>

    <!-- LEGEND (Bottom) -->
    @if(showLegend && legendPosition === 'bottom') {
    <div id="legendContainerBottom" #legendRefBottom
      class="mt-1 flex flex-wrap justify-center items-center gap-x-4 gap-y-2 w-full flex-shrink-0">
    </div>
    }
  </div>

  <!-- LEGEND (Right) -->
  @if(showLegend && legendPosition === 'right') {
  <div id="legendContainerRight" #legendRefRight
    class="ml-1 flex flex-col justify-center h-full overflow-y-auto min-w-[140px] flex-shrink-0"
    style="max-height: 300px;">
  </div>
  }

</div>